export default __webpack_public_path__ + "images/32f74829-question.svg";